import * as React from "react";
const SvgFiRrPlugConnection = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-plug-connection_svg__a)">
      <path
        fill="#062147"
        d="M12.707 12.707 10.414 15 9 13.586l2.293-2.293A1 1 0 1 0 9.88 9.88l-2.293 2.293-1.879-1.879a.999.999 0 1 0-1.414 1.414l.352.352-1.134 1.135a5.166 5.166 0 0 0-.638 6.52l-2.58 2.58a.999.999 0 1 0 1.414 1.413l2.58-2.58c.865.58 1.868.871 2.871.871a5.14 5.14 0 0 0 3.647-1.509l1.135-1.134.352.352a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-1.879-1.879 2.293-2.293a.999.999 0 1 0-1.413-1.414m-3.315 6.368a3.165 3.165 0 0 1-4.467 0 3.163 3.163 0 0 1 0-4.467l1.134-1.135 4.467 4.467zM23.707.293a1 1 0 0 0-1.414 0l-2.58 2.58a5.166 5.166 0 0 0-6.519.638L12.06 4.646l-.353-.353a.999.999 0 1 0-1.414 1.414l8 8a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-.353-.353 1.135-1.135a5.166 5.166 0 0 0 .638-6.519l2.58-2.58a1 1 0 0 0 0-1.414zm-4.632 9.1-1.135 1.134-4.467-4.467 1.135-1.135a3.165 3.165 0 0 1 4.467 0 3.163 3.163 0 0 1 0 4.467"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-plug-connection_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlugConnection;
